module.exports = __webpack_public_path__ + "assets/img/3_1198_big.5f83ac18.jpg";